import { CampoInput } from '@componentsNew/Input/CampoInput';
import { useEffect, useState } from '@wordpress/element';

function Autor({ nota, carregando }) {

  return (
    <CampoInput
      label={'Autor do artigo'}
      carregando={carregando}
      campoEstrutura={'autor'}
      multilinhas={true}
      desabilidato={true}
      nota={nota}
    />
  );
}

export default Autor;
